window.pixelpoint.debug = (function(){

    let localUrls = ['localhost','192.168.1.105', '10.0.0.129'];
    let prepend = 'debugger';

    let checkIfLocal = () => {
        for(var i in localUrls){
            if(window.location.href.indexOf(localUrls[i]) > -1){
                return true;
            }
        }
        return false;
    };

    let dbg = {
        write: (message) => {
            if(checkIfLocal()){
                console.log(message);
            }
        },
        writeFromData(dataAttr, title){
            if(checkIfLocal()){
                title = title || '';
                dataAttr = dataAttr.replace('data-','');
                if($(`[data-${dataAttr}]`).length > 0) {
                    $(`[data-${dataAttr}]`).each((index, element) => {
                        console.log([`${prepend}: ${title}`, $(element).data(dataAttr)]);
                    });
                }
                else{
                    console.log([`${prepend}: ${title}`, 'no data attributes found']);
                }
            }
        }
    };
    return dbg;
  })();